(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  const revealSelector = [
    '#MainContent > .shopify-section',
    '#MainContent .section > :is(.section-content-wrapper, .page-width, .resource-list)',
    '.mb1-story__inner > *',
    '.lr-details > *',
  ].join(',');

  let observer;

  const reveal = (entry) => {
    entry.target.classList.add('is-premium-visible');
    observer?.unobserve(entry.target);
  };

  const prepareElements = (scope = document) => {
    const elements = [...scope.querySelectorAll(revealSelector)].filter(
      (element) => !element.hasAttribute('data-premium-reveal')
    );

    elements.forEach((element, index) => {
      element.setAttribute('data-premium-reveal', 'up');
      element.style.setProperty('--premium-motion-delay', `${Math.min(index % 4, 3) * 55}ms`);

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.94) {
        requestAnimationFrame(() => reveal({ target: element }));
      } else {
        observer.observe(element);
      }
    });
  };

  const start = () => {
    document.documentElement.classList.add('premium-motion-ready');

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    prepareElements();

    let ticking = false;
    const updateHeader = () => {
      document.body.classList.toggle('premium-motion-scrolled', window.scrollY > 18);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateHeader);
        }
      },
      { passive: true }
    );
    updateHeader();

    document.addEventListener('shopify:section:load', (event) => prepareElements(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
